import { useQuery } from "@tanstack/react-query";
import { DocumentLinkService } from "../../../../services/document/document-link.service";
import { useMemo } from "react";

export const useDocumentLinkedById = (id: string | undefined | number) => {
  const docId = id?.toString();
  const { data, ...rest } = useQuery({
    queryKey: ["document-linked", docId],
    queryFn: () => DocumentLinkService.getDocumentLinkedInfos(docId),
    enabled: !!id,
  });

  const docLinkedCount = useMemo(() => (!data ? 0 : data.data.filter((e: any) => !e.isDeleted).length), [data]);

  return { data, docLinkedCount, ...rest };
};
